// 用户管理相关
import request from '@/utils/util.js'

// 修改密码
export function editUserPasswordAPI(data) {
	return request.post('/users/setPassword', data)
}